import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppConfigurationService} from '../../common/app-config/app-configuration.service';
import {map} from 'rxjs/operators';
import {AuthToken} from '../common/common.types';
import {BehaviorSubject, Observable} from 'rxjs';
import {LogManager} from "../../common/log/log.manager";
import {LogCat} from "../../common/log/log.categories";



@Injectable({
  providedIn: 'root'
})
export class AuthTokenRefresherService {
  private tokenWatcher: BehaviorSubject<AuthToken>;
  private timer: any;
  public tokenRefreshWatcher: Observable<AuthToken>;

  constructor(private http: HttpClient,
              private configService: AppConfigurationService ) {

  }


  public StartRefresh(currentToken: AuthToken): Observable<AuthToken>  {
    this.tokenWatcher = new BehaviorSubject<AuthToken>(currentToken);
    this.tokenRefreshWatcher = this.tokenWatcher.asObservable();
    const token = currentToken;
    const expire = token.expires_in;
    this.refreshToken(token.refresh_token, this.safeExpiration(expire));
    return this.tokenRefreshWatcher;
  }

  public Stop(): void {
    this.tokenWatcher.complete();
    clearTimeout(this.timer);
  }

  public invalidateRefreshToken(refreshToken: string): Observable<any> {
    return this.http.post(this.configService.Config.AuthServerUrl + "/OAuth/InvalidateRefreshToken", {refreshToken});
  }
    private refreshToken(token: string, refreshInterval: number)  {
      this.timer = setTimeout(() => {
          this.getNewTokenToken(token).subscribe((newToken) => {
            const expire = newToken.expires_in;
            const newRefreshInterval = this.safeExpiration(expire);
            const newRefreshToken = newToken.refresh_token || token;
            this.refreshToken(newRefreshToken, newRefreshInterval);
          },
          err => {
            LogManager.error(LogCat.Login.TokenRefresh, "token not received");
            // if failed to get a new Token retry every 2 seconds
            this.refreshToken(token, 2000);
          });

      }, refreshInterval * 1000);
  }


  private getNewTokenToken(token: string): Observable<AuthToken> {
    const config =  this.configService.Config;
    const clientId = config.AuthDataParam.clientId;
    const clientSecret = config.AuthDataParam.clientSecret;

    const base64ClientIdentifier = btoa(clientId + ':' + clientSecret);

    const xmlRequestParam = encodeURIComponent('refresh_token') + '=' +
      encodeURIComponent(token) + '&' +
      encodeURIComponent("grant_type") + '=' + encodeURIComponent("refresh_token");

    const reqSpec = {
      headers: new HttpHeaders(
        {
          ["withCredentials"]: "true",
          ["Authorization"]: 'Basic ' + base64ClientIdentifier,
          ["Content-Type"]: 'application/x-www-form-urlencoded;charset=utf-8'
        })
    };

    return this.http.post<AuthToken>(config.AuthServerUrl + '/OAuth/PatientPortalInternalAuth', xmlRequestParam, reqSpec)
      .pipe(map((data: AuthToken) => {
        if (data && data.access_token) {
          this.tokenWatcher.next(data);
        }
        return data;
      }));
  }

  private safeExpiration(expiration: number) {
    return Math.round(expiration / 2);
  }
}
